var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDepartment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.125C0 4.53312 4.53312 0 10.125 0C15.7169 0 20.25 4.53312 20.25 10.125C20.25 15.7169 15.7169 20.25 10.125 20.25C4.53312 20.25 0 15.7169 0 10.125Z",
    fill: "#718EBF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8179 8.4375H24.4688C24.9347 8.4375 25.3125 8.81526 25.3125 9.28125V24.4688C25.3125 24.9347 24.9347 25.3125 24.4688 25.3125H9.28125C8.81526 25.3125 8.4375 24.9347 8.4375 24.4688V21.8179C7.8605 21.7353 7.29695 21.6111 6.75 21.4483V24.4688C6.75 25.8667 7.88328 27 9.28125 27H24.4688C25.8667 27 27 25.8667 27 24.4688V9.28125C27 7.88328 25.8667 6.75 24.4688 6.75H21.4483C21.6111 7.29695 21.7353 7.8605 21.8179 8.4375Z",
    fill: "#718EBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartment);
export default __webpack_public_path__ + "static/media/department.9281750aa35591d6559ec694c5106a60.svg";
export { ForwardRef as ReactComponent };